<template>
  <div id="dashboard-analytics">
    <div class="vx-row" id="destinationclient">
      <div class="vx-col lg:w-full w-full">
        <div class="filters mb-4">
          <label class="mt-2">Minimum amount (EUR)</label>
          <vs-input v-model="filters.minAmount" size="default" />

          <label class="mt-2">Minimum date</label>
          <datepicker :inline="false" v-model="filters.minDate" />

          <label class="mt-2">Maximum date</label>
          <datepicker :inline="false" v-model="filters.maxDate" />

          <label class="mt-2">Tag</label>
          <v-select v-model="filters.quotationTag" :options="quotationTagOptions" placeholder="Select Tag" class="mt-0">
          </v-select>

          <label class="mt-2">Broker</label>
          <v-select v-model="filters.idbroker" :options="brokerOptions" :reduce="option => option.value" label="label"
            placeholder="Select Broker" class="mt-0">
          </v-select>
          <vs-button @click="updateTheFilter" color="primary" class="mt-0">Apply</vs-button>
        </div>
        <vx-card :title="titlePendingQuotation">
          <div slot="no-body" class="mt-0 ml-4 mr-4 mb4">
            <template>
              <div>
                <vs-table :data="pending_quotations" class="table-dark-inverted" search>
                  <template slot="thead">
                    <vs-th></vs-th>
                    <vs-th>Client</vs-th>
                    <vs-th>Number of Quotations</vs-th>
                    <vs-th>Date</vs-th>
                    <vs-th style="float: right">Value (EUR)</vs-th>
                  </template>
                  <template slot-scope="{ data }">
                    <vs-tr :data="tr" :key="tr.clientid" v-for="(tr, index) in data">
                      <!-- Bouton pour ouvrir le popup -->
                      <vs-td>
                        <vs-button @click="openDetailsPopup(tr)" color="primary">
                          Show Details
                        </vs-button>
                      </vs-td>
                      <vs-td>
                        <span>
                          <a :href="getClientUrl(tr.clientid)">{{ tr.client }}</a>
                        </span>
                      </vs-td>
                      <vs-td>
                        <span>{{ tr.total_operations }}</span>
                      </vs-td>
                      <vs-td>
                        <span v-if="tr.late && tr.late > 0" class="flex items-center px-2 py-1 rounded">
                          <div class="h-3 w-3 rounded-full mr-2 bg-success"></div>
                          {{ formattedDate(tr.date) }} (deadline in {{ tr.late }} days)
                        </span>
                        <span v-else-if="tr.late && tr.late <= 0" class="flex items-center px-2 py-1 rounded">
                          <div class="h-3 w-3 rounded-full mr-2 bg-danger"></div>
                          {{ formattedDate(tr.date) }} ({{ Math.abs(tr.late) }} days late)
                        </span>
                        <span v-else class="flex items-center px-2 py-1 rounded">
                          <div class="h-3 w-3 rounded-full mr-2 bg-warning"></div>
                          {{ formattedDate(tr.date) }} (N/A)
                        </span>
                      </vs-td>
                      <vs-td>
                        <span style="float: right">
                          {{ Math.abs(tr.total_quotation_amount).toFixed(2).toLocaleString() }}
                        </span>
                      </vs-td>
                    </vs-tr>
                  </template>
                </vs-table>

                <!-- Popup (modale) -->
                <vs-popup fullscreen title="Details" :active.sync="isPopupVisible" :style="{ zIndex: 10000001 }">
                  <div v-if="selectedRow">
                    <vs-table :data="selectedRow.details" style="width: 100%">
                      <template slot="thead">
                        <vs-th>Quotation</vs-th>
                        <vs-th>Tag</vs-th>
                        <vs-th>Broker</vs-th>
                        <vs-th>Date</vs-th>
                        <vs-th>Value (EUR)</vs-th>
                        <vs-th></vs-th>
                        <vs-th></vs-th>
                        <vs-th></vs-th>
                      </template>
                      <template slot-scope="{ data: innerData }">
                        <vs-tr :data="trr" :key="indextrr" v-for="(trr, indextrr) in innerData">
                          <vs-td>
                            <a :href="getQuotationUrl(trr.id)">Quotation #{{ trr.id }}</a>
                          </vs-td>
                          <vs-td>
                            <vs-button :style="{ fontSize: '12px', fontWeight: 'bold', marginBottom: '10px' }"
                              class="w-full" @click="confirmthechangeofthetag(trr.id)"
                              :color="getButtonColor(trr.quotation_tag)" icon-pack="feather" icon="icon-zap">
                              TAG: {{ trr.quotation_tag || '-' }}
                              {{ tr }}
                            </vs-button>
                          </vs-td>
                          <vs-td>
                            <span>{{ trr.broker_name || '-' }}</span>
                          </vs-td>
                          <vs-td>
                            <span>
                              Date: {{ formattedDate(trr.operation_date) }}
                              <div v-if="trr.date_delivery_desired">(expected {{
                                formattedDate(trr.date_delivery_desired) }})</div>
                            </span>
                          </vs-td>
                          <vs-td>
                            <span style="float: left">
                              {{ Math.abs(trr.quotation_amount).toFixed(2).toLocaleString() }}
                              EUR
                            </span>
                          </vs-td>
                          <vs-td style="width: 250px; text-align: center">
                            <div>
                              <!-- Bouton pour envoyer une quotation -->
                              <vs-button style="font-size: 12px; font-weight: bold; margin-bottom: 10px;" class="w-full"
                                @click="OpenSendMailPopup(trr)" color="primary" icon-pack="feather" icon="icon-mail">
                                Send Quotation
                              </vs-button>

                              <!-- Liste des dates d'envoi -->
                              <div v-if="trr.mail_quotations_dates"
                                style="text-align: left; margin-top: 10px; padding: 5px; border: 1px solid #ddd; border-radius: 5px; background-color: #f9f9f9;">
                                <h5 style="margin: 0; font-size: 13px; color: #555;">Mail History:</h5>
                                <ul style="padding-left: 20px; margin-top: 5px;">
                                  <li v-for="date in trr.mail_quotations_dates" :key="date"
                                    style="font-size: 12px; color: #333;">
                                    <span style="color: #007BFF;">&#8594;</span> Sent on {{ formattedDate(date) }}
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </vs-td>
                          <vs-td style="width: 250px; text-align: center">
                            <vs-button class="w-full" color="success" type="border" icon-pack="feather"
                              icon="icon-check" @click="confirmthechangeofthestatus(trr.id, 1)">
                              Approved
                            </vs-button>
                          </vs-td>
                          <vs-td style="width: 250px; text-align: center">
                            <vs-button class="w-full" color="#c0c0c0" type="border" icon-pack="feather"
                              icon="icon-delete" @click="confirmthechangeofthestatus(trr.id, 2)">
                              Cancel
                            </vs-button>
                          </vs-td>
                        </vs-tr>
                      </template>
                    </vs-table>
                  </div>
                </vs-popup>
              </div>
            </template>
          </div>
        </vx-card>
      </div>

      <vs-popup fullscreen title="Send Mail" :active.sync="popupActiveSendMail" :style="{ zIndex: 10000002 }">
        <div class="my-4">
          <b>From</b>&nbsp;&nbsp;&nbsp;{{ mail_fromname }} ({{ mail_frommail }})
        </div>
        <div class="my-4" style="display: flex; align-items: center;">
          <span><b>To</b>&nbsp;&nbsp;&nbsp;</span>
          <span style="width: 400px;">
            <v-select :options="data_options_mail" v-model="datamail" @input="emailSelected" multiple label="email" :reduce="o => o.email">
              <template #option="{ email, source }">
                <span>{{ email }}</span>
                <vs-chip :color="sourceChipColor(source)" size="small" class="ml-2">{{ sourceChipLabel(source) }}</vs-chip>
              </template>
            </v-select>
          </span>
        </div>
        <!-- Cc : le broker du devis, ajouté par le serveur (operation_ids →
             helpers/brokerCc.js) ; sales@ reste en Bcc comme avant. -->
        <div class="my-4">
          <b>Cc</b>&nbsp;&nbsp;&nbsp;
          <span v-if="brokerCc">{{ brokerCc }} (broker)</span>
          <span v-else class="text-warning">no broker on this quotation</span>
          &nbsp;&mdash;&nbsp;<b>Bcc</b>&nbsp;sales@acaciabois.com
        </div>
        <div class="my-4">
          <b>Object</b>&nbsp;&nbsp;&nbsp;{{ mail_object }}
        </div>
        <div class="my-4">
          <b>Attachment</b>&nbsp;&nbsp;&nbsp;
          <span v-if="quotationPdfUrl">quotation_{{ idquotation }}.pdf</span>
          <span v-else style="color: #ff9f43;">
            No archived PDF for this quotation &mdash; the email will go out with a download link instead.
            Send it once from the quotation screen to archive the PDF.
          </span>
        </div>
        <div class="my-4" style="background-color: #EEE;">
          <b>Content</b>&nbsp;&nbsp;&nbsp;<br />
          <span v-html="mail_hello" style="background-color: #EEE;"></span><br /><br />
          <span v-html="mail_message" style="background-color: #EEE;"></span><br /><br />
          <span v-html="mail_goodbye" style="background-color: #EEE;"></span><br /><br />
          <span v-if="mail_signature" v-html="mail_signature"></span>
        </div>
        <div>
          <!-- Texte pour charger le premier mail -->
          <div style="font-weight: bold; margin-bottom: 15px; color: #000;">
            Currently selected template:
            <span style="color: #ff0000;">
              {{ selectedTemplate === 1 ? 'First Mail' : 'Next Mails' }}
            </span>
          </div>
          <div v-if="selectedTemplate == 2" @click="LoadTemplate1()"
            style="cursor: pointer; color: #ff0000; font-weight: bold; margin-bottom: 10px;">
            <i class="feather icon-download-cloud" style="margin-right: 5px;"></i>
            Load Template - First Mail
          </div>

          <!-- Texte pour charger les mails suivants -->
          <div v-if="selectedTemplate == 1" @click="LoadTemplate2()"
            style="cursor: pointer; color: #ff0000; font-weight: bold; margin-bottom: 10px;">
            <i class="feather icon-download-cloud" style="margin-right: 5px;"></i>
            Load Template - Next Mails
          </div>
        </div>

        <vs-button v-if="sendVisible" class="w-full mt-16" @click="SendQuotation" icon-pack="feather"
          icon="icon-send">Submit
        </vs-button>
        <vs-button v-else class="w-full mt-16" @click="SendQuotation" icon-pack="feather" icon="icon-send"
          disabled>Submit
        </vs-button>


        <div class="my-4" v-if="direct_answer_from_the_server">
          <b>Server Answer : </b>
          {{ direct_answer_from_the_server }}
        </div>

      </vs-popup>

      <vs-popup title="Client Click" :active.sync="popupActiveClientClick">
        <div v-if="clientclick && clientclick.length > 0">
          <div v-for="(mb, index) in clientclick" :key="index" class="institution">
            <div class="institution-info">
              <div class="mt-4">
                <p><b>Description</b> {{ mb.description }}</p>
              </div>
              <div class="mt-4">
                <h4 class="mb-2" style="color:#185c63">Details</h4>
                <p>- <b>IP</b> {{ mb.ip }}</p>
                <p>- <b>Download Date</b> {{ format_date(mb.createdAt, true) }}</p>
              </div>
            </div>
          </div>
          <div>
          </div>
        </div>
        <div v-else>
          <h3 style="text-align:center">No download</h3>
        </div>
      </vs-popup>

      <vs-popup title="Choose a Tag" :active.sync="dialogVisible" :style="{ zIndex: 10000003 }">
        <div
          style="display: flex; flex-direction: column; align-items: center; justify-content: center; text-align: center;">
          <p>{{ dialogText }}</p>
          <!-- Conteneur pour aligner les boutons sur une ligne -->
          <div style="display: flex; justify-content: center; gap: 10px; margin-top: 10px;">
            <vs-button @click="selectTag('A')" color="success">A</vs-button>
            <vs-button @click="selectTag('B')" color="warning">B</vs-button>
            <vs-button @click="selectTag('C')" color="danger">C</vs-button>
          </div>
        </div>
      </vs-popup>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";
import moment from "moment";
import { landingPathFor } from "@/helpers/roleAccess.js";
const themeColors = ["#1292d7", "#EA5455", "#FF9F43", "#28C76F", "#1E1E1E"];
import axios from "@/axios.js";
import moduleDataListDashboard from "@/store/dashboard/moduleOperationList.js";
import Datepicker from "vuejs-datepicker";
import { buildRecipientOptions, pickDefaultRecipients, sourceChipColor, sourceChipLabel } from "@/helpers/mail-recipients.js";
import { getSignatureQuote } from "@/helpers/mail-signature.js";

export default {
  components: {
    vSelect,
    Datepicker,
  },
  data() {
    return {

      isPopupVisible: false, // Contrôle de la visibilité de la modale
      selectedRow: null, // Ligne sélectionnée pour afficher les détails
      filters: {
        minAmount: 0,
        minDate: null,
        maxDate: null,
        quotationTag: 'ALL', // Valeur par défaut
        idbroker: 'ALL', // 'ALL' = tous, 'NONE' = devis sans broker, sinon people.id
      },
      dialogText: "", // Texte dynamique dans le popup
      quotationTagOptions: ['ALL', 'A', 'B', 'C'], // Options disponibles
      // Les deux premieres entrees sont fixes ; la liste des brokers est
      // chargee dans created() depuis /brokers_name/data.
      brokerOptions: [
        { value: 'ALL', label: 'All brokers' },
        { value: 'NONE', label: 'No broker' },
      ],
      data_options_mail: [],
      brokerCc: null, // adresses du broker que le serveur mettra en Cc
      datamail: [],
      mail_object: "",
      mail_hello: "",
      mail_message: "",
      mail_goodbye: "",
      mail_signature: "",
      mail_frommail: "",
      mail_fromname: "",
      // Nom du broker du devis courant : signe le mail, vide => equipe commerciale.
      signerName: null,
      // URL du PDF archive du devis courant (null si jamais archive).
      quotationPdfUrl: null,
      mail_tomail: "",
      popupActiveSendMail: false,
      se_title: null,
      dataNextInvoiceNr: null,
      popupActiveClientClick: false,
      alreadyPaidPopupEur: null,
      totalInvoiceToBePaidPopupEur: null,
      dataAmountPartiallyPaidPopupEur: null,
      dataIdClient: null,
      dataIdInvoicePaid: null,
      lastPopup: null,
      popupActiveRon: false,
      sendVisible: false,
      transactionsRon: [],
      popupActiveEur: false,
      popupActiveAccount: false,
      matchingbank: null,
      idpayment: null,
      idtransaction: null,
      direct_answer_from_the_server: null,
      buttonisshow: true,
      se_idmajoration: null,
      se_whichone: null, // first or second recall
      se_user_id: null,
      se_montant: null,
      se_language: null,
      se_object: null,
      se_content: null,
      se_language_id: null,
      se_facture_no: null,
      se_date: null,
      se_tva: null,
      se_invoice_id: null,
      se_user_email: null,
      se_user_name: null,
      dataAmountPartiallyPaid: 0,
      popupActivePartiallyPaid: false,
      popupActive: false,
      displayExport: false,
      saleList: [],
      getmailstatus: [],
      evolutionEbitda: {},
      monthlyEbitda: {},
      //isGraphFailed: true,
      valueRevenue: [],
      valueVariable: [],
      valueProfit: [],
      valueFixed: [],
      totalUnpaid: "Unpaid Invoices",
      clientclick: [],
      quotationstatus: null,
      idquotation: null,
      language: null,
      selectedTemplate: 1,
      dialogVisible: false,
    };
  },
  watch: {
    dataIdClient(newVal, oldVal) {
      // When dataIdClient changes, reset dataIdInvoicePaid
      this.dataIdInvoicePaid = null;
    }
  },
  computed: {
    pending_quotations() {
      return this.$store.state.dataListDashboard.pending_quotations;
    },
    titlePendingQuotation() {
      const pendingQuotations = this.$store.state.dataListDashboard.pending_quotations;
      const totalDetails = pendingQuotations.reduce((total, item) => {
        return total + (item.details ? item.details.length : 0); // Ajouter la longueur de details si elle existe
      }, 0);
      return `List of Pending Quotations (${totalDetails})`;
    }
  },
  methods: {

    openDetailsPopup(row) {
      this.selectedRow = row; // Affecte la ligne sélectionnée
      this.isPopupVisible = true; // Affiche le popup
    },
    getButtonColor(tag) {
      if (tag === 'A') return 'success'; // Vert
      if (tag === 'B') return 'warning'; // Orange
      if (tag === 'C') return 'danger'; // Rouge
      return 'primary'; // Couleur par défaut
    },

    /*
    filters: {
        minAmount: 0,
        minDate: null,
        maxDate: null,
      },*/
    async updateTheFilter() {
      this.isPopupVisible = false
      const defaultFilter = {
        minDate: this.filters.minDate ? moment(this.filters.minDate).format("YYYY-MM-DD") : null,
        maxDate: this.filters.maxDate ? moment(this.filters.maxDate).format("YYYY-MM-DD") : null,
        minAmount: this.filters.minAmount || 0, // Si minAmount est null ou undefined, utilisez 0
        quotation_tag: (this.filters.quotationTag && this.filters.quotationTag !== 'ALL' ? this.filters.quotationTag : null),
        idbroker: (this.filters.idbroker && this.filters.idbroker !== 'ALL' ? this.filters.idbroker : null),
      };

      this.$vs.loading.close();
      this.$store
        .dispatch("dataListDashboard/fetchListOfPendingQuotation", defaultFilter)
        .then((data) => {
          this.hideAllTables = false;
          this.$vs.loading.close();
        })
        .catch((error) => {
          console.error(error);
          this.$vs.loading.close();
        });
    },
    async getClientClick(idoperation) {
      axios.get("/publicdownloads/data/" + idoperation).then((response) => {
        this.clientclick = response.data;
      }).then(e => {
        this.popupActiveClientClick = true
      });
    },
    formattedDate(ddatte) {
      const dateObj = new Date(ddatte);
      const day = String(dateObj.getUTCDate()).padStart(2, '0');
      const month = String(dateObj.getUTCMonth() + 1).padStart(2, '0'); // Les mois commencent à 0, donc +1 est nécessaire
      const year = dateObj.getUTCFullYear();
      return `${day}-${month}-${year}`;
    },
    getQuotationUrl(id) {
      return "/web/quotation/" + id;
    },
    getClientUrl(id) {
      return "/web/person/" + id;
    },
    emailSelected() {
      // Convertir le tableau d'emails en chaîne de caractères séparée par des ;
      const emailsSeparatedBySemicolon = this.datamail.join(';');
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      // Vérifier que tous les emails sélectionnés sont valides
      const allEmailsValid = this.datamail.every(email => emailRegex.test(email));
      // Afficher ou cacher le bouton d'envoi selon la validité des emails
      this.sendVisible = allEmailsValid;
    },
    LoadTemplate1() {
      this.selectedTemplate = 1;
      this.mail_object = this.getTitleQuote(this.language)
      this.mail_hello = this.getTopMsg(this.language)
      this.mail_message = this.getContentQuote(this.language)
      this.mail_goodbye = this.getBottomMsg(this.language, this.signerName)
      this.mail_frommail = "sales@acaciabois.com"
      this.mail_fromname = this.getName(this.language, this.signerName)
      this.loadSignature()
    },
    LoadTemplate2() {
      this.selectedTemplate = 2;
      this.mail_object = this.getTitleQuoteTemplateTwo(this.language)
      this.mail_hello = this.getTopMsg(this.language)
      this.mail_message = this.getContentQuoteTemplateTwo(this.language)
      this.mail_goodbye = this.getBottomMsg(this.language, this.signerName)
      this.mail_frommail = "sales@acaciabois.com"
      this.mail_fromname = this.getName(this.language, this.signerName)
      this.loadSignature()
    },
    async loadSignature() {
      this.mail_signature = await getSignatureQuote(this.language, this.signerName)
    },
    OpenSendMailPopup(data) {
      if (data.mail_quotations_dates && data.mail_quotations_dates.length > 0) this.selectedTemplate = 2
      else this.selectedTemplate = 1
      this.language = data.language_initials
      this.idquotation = data.id
      // Le broker du devis signe le mail ; le PDF archive (s'il existe) y est joint.
      this.signerName = data.broker_name || null
      this.quotationPdfUrl = data.quotation_pdf_url || null
      this.brokerCc = null
      axios.get("/mail/broker-cc", { params: { operation_ids: data.id } })
        .then((r) => { this.brokerCc = ((r.data && r.data.emails) || []).join("; ") || null })
        .catch(() => { this.brokerCc = null })
      this.popupActiveSendMail = true;
      if (this.selectedTemplate == 1) this.LoadTemplate1()
      else this.LoadTemplate2()
      const options = buildRecipientOptions(data)
      const defaults = pickDefaultRecipients(options, 'general')
      this.data_options_mail = options
      try {
        this.datamail = defaults.map(o => o.email)
        this.sendVisible = this.datamail.length > 0
      } catch (error) {
        this.sendVisible = false
      }

    },
    sourceChipColor,
    sourceChipLabel,
    SendQuotation() {
      this.$vs.loading();
      this.buttonisshow = false;

      var dataz = {
        template_id: "template_cfvx026",
        operation_ids: [this.idquotation], // broker du devis en Cc (serveur)
        template_params: {
          se_title: this.mail_object,
          se_hello: this.mail_hello,
          se_from_email: this.mail_frommail,
          se_message: this.mail_message,
          se_goodbye: this.mail_goodbye,
          se_mail: this.datamail,
          // sendMailPayload ne lit que bcc_email/bcc : avec se_bcc la copie a
          // sales@ etait silencieusement perdue a chaque envoi.
          bcc_email: 'sales@acaciabois.com',
          se_from_name: this.mail_fromname,
          se_signature: this.mail_signature,
        },
      };

      // PDF archive du devis (operations.name) : l'API telecharge l'URL et la
      // joint au mail. Sans PDF archive, le corps garde le lien de telechargement.
      if (this.quotationPdfUrl) {
        dataz.template_params.attachment_content = this.quotationPdfUrl;
        dataz.template_params.filename = `quotation_${this.idquotation}`;
      }

      axios
        .post("/mail/send", dataz)
        .then((response) => {
          if (typeof this.set === "function") {
            this.set(); // Appel sécurisé à la méthode set
          } else {
            console.error("set is not a function or is undefined");
          }

          this.$vs.notify({
            color: "success",
            title: "Email sent correctly!",
            text:
              "Response from the mail server : " +
              response.statusText +
              "/" +
              response.status,
          });

          this.direct_answer_from_the_server =
            response.statusText + "/" + response.status;

          this.sendVisible = false;
          this.setClientSend(this.idquotation);

          this.updateTheFilter()
        })
        .catch((error) => {
          console.log(error);
          this.$vs.notify({
            color: "danger",
            title: "Email NOT sent!",
            text: "Response from the mail server : " + error,
          });
          this.direct_answer_from_the_server = error;
          this.sendVisible = false;
          this.$vs.loading.close();
        });
    },
    async setClientSend(id) {
      axios.get("/publicdownloads/update/" + id).then((response) => {
        this.popupActiveSendMail = false
      })
    },
    // signerName = le broker du devis ; absent (devis encode en interne), on
    // retombe sur la formule generique "equipe commerciale".
    getBottomMsg(language, signerName = null) {
      const lang = language.substring(0, 2).toLowerCase();
      if (lang == "fr")
        return `Cordialement,<br/>${signerName || "L'équipe commerciale"}<br/>Acacia Bois / Xylo Impact`;
      else if (lang == "de")
        return `mfG,<br/>${signerName || "Das Verkaufsteam"}<br/>Robinienpfähle / Xylo Impact`;
      else if (lang == "ro")
        return `Cu stima,<br/>${signerName || "Echipa de vânzări"}<br/>Stalpi Salcam / Xylo Impact`;
      else if (lang == "es")
        return `Atentamente,<br/>${signerName || "el equipo comercial"}<br/>Estacas de Acacia / Xylo Impact`;
      else if (lang == "ne")
        return `Met vriendelijke groeten,<br/>${signerName || "Het verkoopteam"}<br/>Robinia Palen / Xylo Impact`;
      else return `Kind regards,<br/>${signerName || "The sales team"}<br/>Acacia Poles / Xylo Impact`;
    },
    getName(language, signerName = null) {
      const lang = language.substring(0, 2).toLowerCase();
      if (lang == "fr")
        return `${signerName || "L'équipe commerciale"} - Acacia Bois / Xylo Impact`;
      else if (lang == "de")
        return `${signerName || "Das Verkaufsteam"} - Robinienpfählen / Xylo Impact`;
      else if (lang == "ro")
        return `${signerName || "Echipa de vânzări"} - Stalpi Salcam / Xylo Impact`;
      else if (lang == "es")
        return `${signerName || "El equipo comercial"} - Estacas de acacia / Xylo Impact`;
      else if (lang == "ne")
        return `${signerName || "Het verkoopteam"} - Robinia Palen / Xylo Impact`;
      else return `${signerName || "The sales team"} - Acacia Poles / Xylo Impact`;
    },
    getTopMsg(language) {
      if (language.substring(0, 2).toLowerCase() == "fr")
        return "Madame, Monsieur,";
      else if (language.substring(0, 2).toLowerCase() == "de") return "Hallo,";
      else if (language.substring(0, 2).toLowerCase() == "ro")
        return "Dragă,";
      else if (language.substring(0, 2).toLowerCase() == "es") return "Señora, Señor,";
      else if (language.substring(0, 2).toLowerCase() == "ne") return "Beste,";
      else return "Hi,";
    },
    getTitleQuote(language) {
      if (language.substring(0, 2).toLowerCase() == "fr")
        return "Devis #" + this.idquotation + " - Acacia Bois / Xylo Impact";
      else if (language.substring(0, 2).toLowerCase() == "de")
        return "Angebot #" + this.idquotation + " - Robinienpfähle / Xylo Impact";
      else if (language.substring(0, 2).toLowerCase() == "ro")
        return "Oferta #" + this.idquotation + " - Stalpi Salcam / Xylo Impact";
      else if (language.substring(0, 2).toLowerCase() == "es")
        return "Presupuesto #" + this.idquotation + " - Estacas de Acacia / Xylo Impact";
      else if (language.substring(0, 2).toLowerCase() == "ne")
        return "Offerte #" + this.idquotation + " - Robinia Palen / Xylo Impact";
      else return "Quote #" + this.idquotation + " - Acacia Poles / Xylo Impact";
    },
    // Phrase de mise a disposition du devis : piece jointe quand le PDF archive
    // existe, sinon on retombe sur le lien de telechargement.
    getQuoteDeliverySentence(lang) {
      const id = this.idquotation;
      if (this.quotationPdfUrl) {
        const attached = {
          fr: `Vous trouverez votre devis #${id} en pièce jointe de cet e-mail.`,
          de: `Ihr Angebot #${id} finden Sie im Anhang dieser E-Mail.`,
          ro: `Găsiți oferta #${id} atașată acestui e-mail.`,
          es: `Encontrará su presupuesto #${id} adjunto a este correo electrónico.`,
          ne: `U vindt uw offerte #${id} in bijlage bij deze e-mail.`,
        };
        return attached[lang] || `You will find your quote #${id} attached to this email.`;
      }
      const baseUrl = "https://xylo.codesinn.com/web/download-quotation/protected-8458451512544qsfjfskfr8224f_fqi2/";
      const href = baseUrl + id;
      const linked = {
        fr: `Vous pouvez télécharger votre devis #${id} via ce <a href="${href}">lien</a>.`,
        de: `Sie können Ihr Angebot #${id} über diesen <a href="${href}">Link</a> herunterladen.`,
        ro: `Puteți descărca oferta #${id} prin acest <a href="${href}">link</a>.`,
        es: `Puede descargar su presupuesto #${id} a través de este <a href="${href}">enlace</a>.`,
        ne: `U kunt uw offerte #${id} downloaden via deze <a href="${href}">link</a>.`,
      };
      return linked[lang] || `You can download your quote #${id} via this <a href="${href}">link</a>.`;
    },
    getContentQuote(language) {
      const lang = language.substring(0, 2).toLowerCase();
      const delivery = this.getQuoteDeliverySentence(lang);

      if (lang == "fr")
        return `Nous avons préparé votre devis en fonction de vos besoins spécifiques.<br/><br/>${delivery}<br/><br/>Si vous avez des questions ou souhaitez modifier ce devis, n'hésitez pas à répondre à cet e-mail.<br/><br/>Merci de votre confiance.`;
      else if (lang == "de")
        return `Wir haben Ihr Angebot entsprechend Ihren spezifischen Anforderungen vorbereitet.<br/><br/>${delivery}<br/><br/>Falls Sie Fragen haben oder das Angebot ändern möchten, antworten Sie bitte auf diese E-Mail.<br/><br/>Vielen Dank für Ihr Vertrauen.`;
      else if (lang == "ro")
        return `Am pregătit oferta dumneavoastră conform nevoilor specifice.<br/><br/>${delivery}<br/><br/>Dacă aveți întrebări sau doriți să modificați această ofertă, răspundeți acestui e-mail.<br/><br/>Vă mulțumim pentru încrederea acordată.`;
      else if (lang == "es")
        return `Hemos preparado su presupuesto según sus necesidades específicas.<br/><br/>${delivery}<br/><br/>Si tiene alguna pregunta o desea modificar este presupuesto, no dude en responder a este correo electrónico.<br/><br/>Gracias por su confianza.`;
      else if (lang == "ne")
        return `We hebben uw offerte opgesteld op basis van uw specifieke behoeften.<br/><br/>${delivery}<br/><br/>Als u vragen heeft of dit aanbod wilt aanpassen, antwoord dan gerust op deze e-mail.<br/><br/>Dank u voor uw vertrouwen.`;
      else
        return `We have prepared your quote based on your specific needs.<br/><br/>${delivery}<br/><br/>If you have any questions or wish to modify this quote, feel free to reply to this email.<br/><br/>Thank you for your trust.`;
    },
    getTitleQuoteTemplateTwo(language) {
      const id = this.idquotation; // ID du devis pour simplifier
      const titles = {
        fr: `Rappel - Avez-vous bien reçu votre devis #${id} ?`,
        de: `Erinnerung - Haben Sie Ihr Angebot #${id} erhalten?`,
        ro: `Reamintire - Ați primit oferta dumneavoastră #${id}?`,
        es: `Recordatorio - ¿Ha recibido su presupuesto #${id}?`,
        ne: `Herinnering - Heeft u uw offerte #${id} ontvangen?`,
        default: `Reminder - Did you receive your quote #${id}?`,
      };

      // Récupère la langue (les deux premiers caractères) en minuscules
      const lang = language.substring(0, 2).toLowerCase();

      // Retourne le titre correspondant ou la valeur par défaut
      return titles[lang] || titles.default;
    },
    getContentQuoteTemplateTwo(language) {
      const lang = language.substring(0, 2).toLowerCase();
      const id = this.idquotation;
      const attached = !!this.quotationPdfUrl;

      if (lang === "fr") {
        const again = attached
          ? `Vous retrouverez votre devis #${id} en pièce jointe de cet e-mail.`
          : `Dans le cas où vous n’auriez pas encore consulté votre devis : ${this.getQuoteDeliverySentence(lang)}`;
        return `
      Nous espérons que vous avez bien reçu votre devis #${id}, envoyé récemment, et que celui-ci répond à vos attentes.<br/><br/>
      Si vous avez des questions ou besoin de modifications, nous restons à votre disposition. N’hésitez pas à répondre directement à cet e-mail pour toute demande ou précision.<br/><br/>
      ${again}<br/><br/>
      Nous restons à votre écoute et prêts à vous accompagner.<br/><br/>
    `;
      } else if (lang === "de") {
        const again = attached
          ? `Ihr Angebot #${id} finden Sie erneut im Anhang dieser E-Mail.`
          : this.getQuoteDeliverySentence(lang);
        return `
      Wir hoffen, dass Sie Ihr Angebot #${id}, das wir Ihnen kürzlich gesendet haben, erhalten haben und dass es Ihren Erwartungen entspricht.<br/><br/>
      Falls Sie Fragen haben oder Änderungen wünschen, stehen wir Ihnen gerne zur Verfügung. Bitte antworten Sie direkt auf diese E-Mail.<br/><br/>
      ${again}<br/><br/>
      Wir stehen Ihnen gerne zur Verfügung.
    `;
      } else if (lang === "ro") {
        const again = attached
          ? `Regăsiți oferta #${id} atașată acestui e-mail.`
          : this.getQuoteDeliverySentence(lang);
        return `
      Sperăm că ați primit oferta #${id}, trimisă recent, și că aceasta corespunde așteptărilor dumneavoastră.<br/><br/>
      Dacă aveți întrebări sau aveți nevoie de modificări, vă stăm la dispoziție. Nu ezitați să răspundeți direct la acest e-mail.<br/><br/>
      ${again}<br/><br/>
      Suntem aici pentru a vă sprijini.
    `;
      } else if (lang === "es") {
        const again = attached
          ? `Encontrará de nuevo su presupuesto #${id} adjunto a este correo electrónico.`
          : this.getQuoteDeliverySentence(lang);
        return `
      Esperamos que haya recibido su presupuesto #${id}, enviado recientemente, y que este cumpla con sus expectativas.<br/><br/>
      Si tiene preguntas o necesita modificaciones, estamos a su disposición. No dude en responder directamente a este correo electrónico.<br/><br/>
      ${again}<br/><br/>
      Estamos aquí para ayudarle.
    `;
      } else if (lang === "ne") {
        const again = attached
          ? `U vindt uw offerte #${id} opnieuw in bijlage bij deze e-mail.`
          : this.getQuoteDeliverySentence(lang);
        return `
      We hopen dat u uw offerte #${id}, die we onlangs hebben verzonden, heeft ontvangen en dat deze aan uw verwachtingen voldoet.<br/><br/>
      Als u vragen heeft of wijzigingen nodig heeft, staan wij voor u klaar. U kunt direct op deze e-mail reageren.<br/><br/>
      ${again}<br/><br/>
      Wij staan klaar om u te helpen.
    `;
      } else {
        const again = attached
          ? `You will find your quote #${id} attached again to this email.`
          : this.getQuoteDeliverySentence(lang);
        return `
      We hope you received your quote #${id}, sent recently, and that it meets your expectations.<br/><br/>
      If you have any questions or need modifications, we are here to help. Feel free to reply directly to this email.<br/><br/>
      ${again}<br/><br/>
      We are at your service and ready to assist you.
    `;
      }
    },

    async getClientClick() {
      axios.get("/publicdownloads/data/" + this.$route.params.userId).then((response) => {
        this.clientclick = response.data;
      }).then(e => {
        this.popupActiveClientClick = true
      });
    },
    changethetag() {

    },
    confirmthechangeofthetag(idquotation) {
      this.idquotation = idquotation;
      this.dialogText = `Which Tag for quotation #${idquotation}?`;
      this.dialogVisible = true; // Ouvrir le dialogue
    },
    selectTag(tag) {
      this.$vs.loading();
      axios
        .post("/pendingquotations/updatetag", {
          quotation_tag: tag,
          id: this.idquotation,
        })
        .then((response) => {
          this.dialogVisible = false;
          this.updateTheFilter()
        })
        .catch(() => { });

    },
    changethestatus() {
      this.$vs.loading();
      axios
        .post("/pendingquotations/updatestatus", {
          idquotationstatus: this.quotationstatus,
          id: this.idquotation,
        })
        .then((response) => {
          this.updateTheFilter()
        })
        .catch(() => { });
    },
    confirmthechangeofthestatus(idquotation, type) {
      this.isPopupVisible = false;
      let phraseVal = null
      let color = null
      if (type == 1) {
        this.quotationstatus = 2
        phraseVal = `You are about to approve the quotation #${idquotation}!`
        color = 'success'
      }
      if (type == 2) {
        this.quotationstatus = 3
        phraseVal = `You are about to cancel the quotation #${idquotation}!`
        color = 'danger'
      }
      this.idquotation = idquotation
      this.$vs.dialog({
        type: "confirm",
        color: color,
        title: "Quotation status",
        text: phraseVal,
        accept: this.changethestatus,
        acceptText: "Yes!",
      });
    },
    sleep(ms) {
      return new Promise((resolve) => {
        setTimeout(resolve, ms);
      });
    },
    gotoclient(id) {
      return { path: "/person-edit/" + id };
    },
    splitedListPointVirgule(row) {
      return row !== null ? row.split(";") : "";
    },
    splitedListVirgule(row) {
      return row !== null ? row.split(",") : "";
    },
  },
  created() {
    this.$vs.loading();
    if (localStorage.getItem("login-roles").toLowerCase().includes("accountant")) this.$router.push({ path: landingPathFor() })
    if (localStorage.getItem("login-roles").toLowerCase().includes("admin") || localStorage.getItem("login-roles").toLowerCase().includes("moderator")) {
      this.displayExport = true;
      if (!moduleDataListDashboard.isRegistered) {
        this.$store.registerModule(
          "dataListDashboard",
          moduleDataListDashboard
        );
        moduleDataListDashboard.isRegistered = true;
      }

      // Ne renseigner que les dates/montant : ecraser this.filters en bloc
      // (avec une cle quotation_tag au lieu de quotationTag) vidait les
      // v-select Tag et Broker des le premier chargement.
      this.filters.minDate = moment().subtract(3, "month").format("YYYY-MM-DD");
      this.filters.maxDate = moment().add(1, "year").format("YYYY-MM-DD");
      this.filters.minAmount = 0;

      axios.get("/brokers_name/data")
        .then((response) => {
          this.brokerOptions = this.brokerOptions.concat(response.data);
        })
        .catch((error) => {
          console.error("Broker list could not be loaded:", error);
        });

      // updateTheFilter() construit le payload attendu par l'API (quotation_tag
      // / idbroker a null quand le filtre vaut ALL) et ferme le loader.
      this.updateTheFilter();
    } else {
      this.$vs.notify({
        title: "Denied",
        text: "Access to the Finance page is reserved for administrators",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "danger",
        position: "bottom-right",
        time: 8000,
      });
      this.$router.push({ path: "/dashboard/analytics" });
    }
  },
};
</script>
<style lang="scss">
.filters {
  display: flex;
  gap: 1rem;
}

.filters label {
  margin-right: 0.5rem;
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  /* Espacer le titre et l'image */
}

.header h4 {
  margin: 0;
  /* Enlever la marge par défaut du titre pour un alignement correct */
}

.header img {
  height: 64px;
  /* Ajuster la taille de l'image selon le besoin */
}


#dashboard-analytics {
  .greet-user {
    position: relative;

    .decore-left {
      position: absolute;
      left: 0;
      top: 0;
    }

    .decore-right {
      position: absolute;
      right: 0;
      top: 0;
    }
  }

  @media (max-width: 576px) {

    .decore-left,
    .decore-right {
      width: 140px;
    }
  }
}

.institution {
  display: flex;
  align-items: center;
  background-color: #f9f9f9;
  border: 1px solid #eaeaea;
  border-radius: 10px;
  padding: 10px;
  margin-bottom: 10px;
  transition: background-color 0.3s ease;
}

.institution:hover {
  background-color: #e6f7ff;
}

.institution img {
  margin-right: 15px;
  border-radius: 5px;
}

.institution-info {
  flex-grow: 1;
}

/*! rtl:end:ignore */
</style>
